module.exports = __webpack_public_path__ + "img/ring_g_c_1_0@3x.4c3619b6.png";